/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ variance: NonNullable<unknown> }} Stocktake_Approve_Dialog_VarianceInputs */

const vi_stocktake_approve_dialog_variance = /** @type {(inputs: Stocktake_Approve_Dialog_VarianceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.variance} dòng có sai lệch`)
};

/**

* @param {Stocktake_Approve_Dialog_VarianceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_approve_dialog_variance = /** @type {((inputs: Stocktake_Approve_Dialog_VarianceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Approve_Dialog_VarianceInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_approve_dialog_variance(inputs)
});